import { assign, join, map, filter } from "lodash-es";
import $ from "jquery";
import shared from "./_shared";

// AUDIO
const audioOptions = assign({}, shared.videoJSOptions, {
    controlBar: {
        children: ["playToggle", "wrapperComponent"],
        wrapperComponent: {
            className: "vjs-control-bar--inner",
            children: ["wrapperComponent", "WrapperComponent"],
            wrapperComponent: {
                className: "vjs-control-bar--inner-block",
                children: ["wrapperComponent", "wrapperComponent"],
                wrapperComponent: {
                    className: "marquee",
                    children: ["wrapperComponent"],
                    wrapperComponent: {
                        className: "marquee__content",
                    },
                },
            },
            WrapperComponent: {
                className: "vjs-control-bar--inner-block",
                children: ["currentTimeDisplay", "progressControl", "durationDisplay"],
            },
        },
    },
});

export default async ({
    videojs,
    container,
    el,
    isEdit,
    fromFroala,
    filestack,
    isExport,
    getDynamicMediaData,
    onProgress,
}) => {
    const $el = $(el);
    if (Object.prototype.hasOwnProperty.call(shared.audioStack, $el.attr("data-v-id"))) {
        return;
    }

    const media = shared._vjsEncode($el.data("media"), true);
    if (media.id && (getDynamicMediaData || (getDynamicMediaData && !isExport))) {
        const { metadata, poster } = await getDynamicMediaData(media.id).catch(() => media);
        media.metadata = metadata;
        media.poster = poster;
    }
    const poster = media.poster;
    const url = media.url;
    const metadata = media.metadata;
    const id = `audio_${Math.floor(Math.random() * 1000 + 1)}`;
    $el.attr("data-v-id", id);
    $el.attr("id", id);

    const hasPoster = !!shared._getOptionsPoster({ options: {}, poster, container, media }).poster;

    const settings = shared._getSettings($el, audioOptions);

    let options = settings.options;
    options.sources = [{ type: media.type, src: url }];
    options = shared._getOptionsPoster({ options, poster, container, media, filestack });

    const audioPlayer = videojs(el, options);
    shared.audioStack[id] = audioPlayer;

    shared._extraClasses(audioPlayer, isEdit, fromFroala);

    const $audioPlayer = $(audioPlayer.el());
    $audioPlayer.toggleClass("vjs-audio--has-poster", hasPoster);
    $audioPlayer.addClass("vjs-audio--big-player");

    let audioPlayerResize;
    if (!settings.customOptions) {
        let marqueeContent;
        let marqueeContentSub;

        const trackAuthor = (metadata && metadata.trackAuthor) || "";
        const trackTitle = (metadata && metadata.trackTitle) || "";

        if (hasPoster) {
            if (trackAuthor !== "" || trackTitle !== "") {
                marqueeContent = $audioPlayer.find(".marquee__content").first();
                marqueeContentSub = $audioPlayer.find(".marquee__content").last();

                marqueeContent.text(trackTitle);
                marqueeContentSub.text(trackAuthor);
            } else {
                $(".vjs-control-bar--inner-block")
                    .first()
                    .remove();
                $(".vjs-control-bar--inner-block")
                    .first()
                    .css("height", "100%");
            }
        } else {
            $audioPlayer
                .find(".marquee")
                .last()
                .remove();
            marqueeContent = $audioPlayer.find(".marquee__content");

            marqueeContent.parent().toggleClass("marquee--single", !trackTitle || !trackAuthor);
            if (trackAuthor !== "" || trackTitle !== "") {
                const content = join(
                    map(filter([trackTitle, trackAuthor], e => !!e), el => `<span>${el}</span>`),
                    "<span class='marquee__content--separator'>&nbsp;-&nbsp;</span>",
                );
                marqueeContent.html(content);
            } else {
                marqueeContent
                    .parent()
                    .parent()
                    .css("height", "9px");
            }
        }

        audioPlayerResize = () => {
            if (marqueeContent) {
                marqueeContent
                    .parent()
                    .toggleClass("animation-play", marqueeContent.width() > marqueeContent.parent().width());
            }

            if (hasPoster && marqueeContentSub) {
                marqueeContentSub
                    .parent()
                    .toggleClass("animation-play", marqueeContentSub.width() > marqueeContentSub.parent().width());
            }
        };
    }

    audioPlayer.on("play", () => {
        shared._pauseMedias(id);
    });

    audioPlayer.on("ended", () => {
        onProgress.call(null, audioPlayer, "ended");
    });

    audioPlayer.on("seeked", () => {
        onProgress.call(null, audioPlayer, "seeked");
    });

    audioPlayer.on("pause", () => {
        onProgress.call(null, audioPlayer, "pause");
    });

    /* For iframe resizers event on load: IE, Firefox */
    if (!audioPlayer.resizeManager.ResizeObserver) {
        shared._playerResize(audioPlayer, audioPlayerResize);
    }

    audioPlayer.on("playerresize", () => {
        shared._playerResize(audioPlayer, audioPlayerResize);
    });

    shared._initMarkers(audioPlayer, settings.markersOptions);
    audioPlayer.a11y();

    return audioPlayer;
};
